import Cookies from 'js-cookie';

export const Store = function () {
	return {
		get( name ) {
			const val = Cookies.get( name );
			return val ? JSON.parse( val ) : val;
		},
		set( name, value, attributes ) {
			const isObj = Object.getPrototypeOf( value ) === Object.prototype;
			Cookies.set(
				name,
				isObj ? JSON.stringify( value ) : value,
				attributes
			);
		},
		remove( name, attributes ) {
			Cookies.remove( name, attributes );
		},
	};
};
